import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import NotFound from "@/pages/NotFound";
import { Route, Switch } from "wouter";
import ErrorBoundary from "./components/ErrorBoundary";
import { ThemeProvider } from "./contexts/ThemeContext";
import SplashScreen from "./components/SplashScreen";
import OnboardingTutorial from "./components/OnboardingTutorial";
import IOSBrowserBlocker from "./components/IOSBrowserBlocker";
import PWAInstallationSuccess from "./components/PWAInstallationSuccess";
import { useState } from "react";
import Home from "./pages/Home";
import NotificationSettings from "./pages/NotificationSettings";
import PredictNew from "./pages/PredictNew";
import History from "./pages/History";
import Statistics from "./pages/Statistics";
import SavedNumbers from "./pages/SavedNumbers";
import Admin from "./pages/Admin";
import AdminDeployments from "./pages/AdminDeployments";
import Profile from "./pages/Profile";
import Insights from "./pages/Insights";

function Router() {
  return (
    <Switch>
      <Route path="/" component={Home} />
      <Route path={"/predict"} component={PredictNew} />     <Route path="/history" component={History} />
      <Route path="/statistics" component={Statistics} />
      <Route path="/saved" component={SavedNumbers} />
      <Route path="/profile" component={Profile} />
      <Route path="/insights" component={Insights} />
      <Route path="/admin" component={Admin} />
      <Route path="/admin/deployments" component={AdminDeployments} />
      <Route path="/notifications" component={NotificationSettings} />
      <Route path="/404" component={NotFound} />
      <Route component={NotFound} />
    </Switch>
  );
}

function App() {
  const [showSplash, setShowSplash] = useState(true);

  // Check iOS browser FIRST before anything else (including splash screen)
  // This prevents localStorage crashes during splash screen
  return (
    <ErrorBoundary>
      <IOSBrowserBlocker>
        {showSplash ? (
          <SplashScreen onFinish={() => setShowSplash(false)} />
        ) : (
          <ThemeProvider defaultTheme="dark">
            <TooltipProvider>
              <Toaster />
              <PWAInstallationSuccess />
              <OnboardingTutorial>
                <Router />
              </OnboardingTutorial>
            </TooltipProvider>
          </ThemeProvider>
        )}
      </IOSBrowserBlocker>
    </ErrorBoundary>
  );
}

export default App;
